import React from 'react';
import numeral from 'numeral';
import { useClient } from 'shared/apollo';
import TrueImpactModal from 'shared/design-system/components/TrueImpactModal';
import { Typography, Button } from '@mui/material';
import { Heading, RowH, ColH, LinkClear, CloseIcon } from './styles';
import { mergeAccounts } from './api';
import InfoIcon from '@mui/icons-material/Info';
import MergeType from '@mui/icons-material/MergeType';

const MergeModal: React.FC = ({ open, setOpen, handleClose, handleCancel, handleCompleted, main, secondary }) => {
    const client = useClient();

    const handleSubmit = async () => {
        await mergeAccounts(client, {
          main: main.dbId,
          secondary: secondary.dbId
        });
        handleCompleted();
    };

    return (
      <TrueImpactModal
        open={open}
        hideHeader={true}
        hideFooter={true}
        onClose={() => setOpen(false)}
      >
        <Heading>
          <CloseIcon onClick={handleCancel} />
          <RowH>
            <ColH>
              <Typography variant="h2">Merging Accounts</Typography>
            </ColH>
          </RowH>
          <RowH>
            <Typography variant="body1">Main account: <b>{main?.name||'-'}</b> (ID: <b>{main?.dbId}</b>)
            Email: <b>{main?.users?.[0]?.email || '-'}</b></Typography>
          </RowH>
          <RowH>
            <Typography variant="body1">Secondary account: <b>{secondary?.name||'-'}</b> (ID: <b>{secondary?.dbId}</b>)
            Email: <b>{secondary?.users?.[0]?.email || '-'}</b></Typography>
          </RowH>
        </Heading>
        <ColH style={{paddingLeft: '25%', paddingRight: '25%', paddingTop: '20px', paddingBottom: '10px'}}>
          <Typography
            variant="body2"
            style={{paddingBottom: '20px'}}
          >By merging an account, all existing reports, allocations, and users from the secondary account will be automatically transferred
          to the main account. The main account will retain its name and data and will assume ownership of the aforementioned elements from
          the secondary account. The secondary account will then be disabled. Please note that this process is irreversible</Typography>
          <RowH>
            { main && secondary && (<ColH><Button fullwidth onClick={handleSubmit}>Confirm & Merge</Button></ColH>)}
            { !secondary && (<ColH><LinkClear onClick={handleClose}>Select the secondary Account</LinkClear></ColH>)}
            <ColH style={{textAlign: 'center'}}><LinkClear onClick={handleCancel}>Cancel Merge</LinkClear></ColH>
          </RowH>
        </ColH>
        <ColH style={{paddingLeft: '25%', paddingRight: '25%', paddingBottom: '10px'}}>
          <Typography variant="caption" style={{paddingBottom: '10px'}}>
            <InfoIcon style={{transform: 'translateY(6px)', marginRight: '10px'}}/><b>Need help?</b>: When pressing on "Select the secondary
            Account" you will be redirected to the account list. The next account you select will be considered the secondary account, whose
            data will be merged into the primary selected account.
          </Typography>
          <div>
            <MergeType
              style={{transform: 'translateY(6px)', marginRight: '10px'}}
              color="primary"
            /><Typography variant="caption"><b>Selected account</b>: indicate the primary account that has already been selected; it will be
            highlighted in blue. Press it again to unselect.</Typography>
          </div>
          <div>
            <MergeType
              style={{transform: 'translateY(6px)', marginRight: '10px'}}
              color="disabled"
            /><Typography variant="caption"><b>Unselected account</b>: Indicates the accounts available for selection.</Typography>
          </div>
        </ColH>
      </TrueImpactModal>
    );
};

export default MergeModal;
